import React, { useState, useEffect } from "react";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import Modal from "react-bootstrap/Modal";
import { Link, useNavigate } from "react-router-dom";
import DeleteAlert from "../../Common/Layout/DeleteAlert";
import Login from "../../Authentication/Login";
import SettingsTabs from "../AllTabs/SettingsTabs";
const initialFieldValues = {
  paymentGatewayId: "00000000-0000-0000-0000-000000000000",
  companyId: "00000000-0000-0000-0000-000000000000",
  paymentGatewayName: "",
  devapiurl: "",
  devapisecret: "",
  devapikey: "",
  prodapiurl: "",
  prodapisecret: "",
  prodapikey: "",
  type: "",
  transactionFee: 0,
};
const PaymentGateway = () => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const [btnLoading, setBtnLoading] = useState(false);
  const [lists, setLists] = useState([]);
  const [values, setValues] = useState(initialFieldValues);
  const [errors, setErrors] = useState({});
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [addShow, setAddShow] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const handleOpenDeleteModal = (id) => {
    setItemToDelete(id);
    setShowDeleteModal(true);
  };
  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setItemToDelete(null);
  };
  const handleAddClose = () => {
    setAddShow(false);
    setRecordForEdit(null);
  };
  const handleAddShow = () => {
    setRecordForEdit(null); // Clear any previous edit
    setValues(initialFieldValues); // Reset form
    setAddShow(true);
  };
  useEffect(() => {
    if (recordForEdit !== null) {
      setValues(recordForEdit);
    }
  }, [recordForEdit]);
  const GetData = async (pageNumber) => {
    const res = await apiService.get(
      `${config.GETPAYMENTGATEWAYBYCOMPANY}/${user?.cid}`,
      pageSize,
      pageNumber
    );
    console.log(res);
    setLists(res.data);
    setPageNumber(res.pageNumber);
    setPageSize(res.pageSize);
    setTotalPages(res.totalPages);
    setData(res.data);
    setTotalRecords(res.totalRecords);
  };
  const GetLastPageData = () => {
    GetData(totalPages);
  };
  const GetFirstPageData = () => {
    GetData("1");
  };
  const GetPageData = (number) => {
    setPageNumber(number);
    if (pageNumber !== number) GetData(number);
  };
  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }
  const renderPageNumbers = pageNumbers.map((number) => {
    return (
      <li
        className="page-item"
        key={number}
        id={number}
        onClick={() => GetPageData(number)}
      >
        <Link className="page-link">{number}</Link>
      </li>
    );
  });
  const showEditDetails = (data) => {
    setRecordForEdit(data);
    setValues(data);
    setAddShow(true);
  };
  const handleDelete = async () => {
    if (itemToDelete !== null) {
      try {
        await apiService.remove(config.DELETEPAYMENTGATEWAY, itemToDelete);
        await GetData(pageNumber);
      } catch (error) {
        // Error toast already handled by apiService
        // Optionally log or track error here
      }
      handleCloseDeleteModal();
    }
  };
  const validate = () => {
    let temp = {};
    temp.paymentGatewayName = values.paymentGatewayName === "" ? false : true;
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setBtnLoading(true);
      var formData = {
        paymentGatewayId: values.paymentGatewayId,
        paymentGatewayName: values.paymentGatewayName,
        devapikey: values.devapikey,
        devapisecret: values.devapisecret,
        devapiurl: values.devapiurl,
        prodapikey: values.prodapikey,
        prodapisecret: values.prodapisecret,
        prodapiurl: values.prodapiurl,
        type: values.type,
        transactionFee: values.transactionFee,
        companyId: user?.cid,
      };
      console.log("🚀 Submitting Payment Gateway Payload:", formData);

      try {
        const isNew =
          formData.paymentGatewayId === "00000000-0000-0000-0000-000000000000";

        if (isNew) {
          await apiService.create(config.CREATEPAYMENTGATEWAY, formData);
        } else {
          await apiService.update(config.UPDATEPAYMENTGATEWAY, formData);
        }
        await GetData(pageNumber);
        resetForm();
      } finally {
        setBtnLoading(false); // ensure loading button resets even on error
      }
    }
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const fieldsToUppercase = ["paymentGatewayName"];
    setValues({
      ...values,
      [name]: fieldsToUppercase.includes(name) ? value.toUpperCase() : value,
    });
  };
  const resetForm = () => {
    setValues(initialFieldValues);
    setAddShow(false);
    setBtnLoading(false);
  };
  const applyErrorClass = (field) =>
    field in errors && errors[field] === false ? " form-control-danger" : "";
  useEffect(() => {
    if (user && !loading) {
      GetData(pageNumber);
    }
  }, [user, loading]);
  if (loading) return <p>Loading...</p>;
  if (!user) {
    navigate("/");
  }
  return (
    <div id="layout-wrapper">
      <Header User={user} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="col-xl-12">
              <div className="card">
                <div className="p-2">
                  <SettingsTabs pageName="PAYMENTGATEWAY" />
                </div>
                <div className="me-2 pb-1">
                  <div className="row g-4 align-items-center">
                    <div className="col-sm-auto ms-auto">
                      <div className="hstack gap-2">
                        <button
                          type="button"
                          className="btn btn-primary add-btn"
                          onClick={handleAddShow}
                        >
                          <i className="ri-add-line align-bottom me-1" /> Add
                          Payment Gateway
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <div className="table-responsive table-card p-2">
                    <table className="table align-middle" id="customerTable">
                      <thead className="bg-soft-success bg-gradient">
                        <tr>
                          <th>Id</th>
                          <th>Payment Gateway</th>
                          <th>Fee</th>
                          <th>Type</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody className="list form-check-all">
                        {lists.length > 0 &&
                          lists.map((v, index) => (
                            <tr key={v.paymentGatewayId}>
                              <td>{index + 1}</td>
                              <td>{v.paymentGatewayName}</td>
                              <td>{v.transactionFee}</td>
                              <td>{v.type}</td>
                              <td>
                                <ul className="list-inline hstack gap-2 mb-0">
                                  <li
                                    className="list-inline-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-trigger="hover"
                                    data-bs-placement="top"
                                    title="Edit"
                                  >
                                    <Link
                                      className="edit-item-btn"
                                      onClick={(e) => showEditDetails(v)}
                                    >
                                      <i className="ri-pencil-fill align-bottom text-muted" />
                                    </Link>
                                  </li>
                                  <li
                                    className="list-inline-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-trigger="hover"
                                    data-bs-placement="top"
                                    title="Delete"
                                  >
                                    <Link
                                      className="remove-item-btn"
                                      onClick={(e) =>
                                        handleOpenDeleteModal(
                                          v.paymentGatewayId
                                        )
                                      }
                                    >
                                      <i className="ri-delete-bin-fill align-bottom text-muted" />
                                    </Link>
                                  </li>
                                </ul>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                    <div className="flex-shrink-0">
                      <div className="text-muted">
                        Showing{" "}
                        <span className="fw-semibold">{lists.length}</span> of{" "}
                        <span className="fw-semibold">{totalRecords}</span>{" "}
                        Results
                      </div>
                    </div>
                    <ul className="pagination pagination-separated pagination-sm mb-0">
                      <li
                        className={
                          "page-item" + data.previousPage === null
                            ? "disabled"
                            : ""
                        }
                        onClick={() => GetFirstPageData()}
                      >
                        <Link className="page-link">Previous</Link>
                      </li>
                      {renderPageNumbers}
                      <li
                        className={
                          "page-item" + data.nextPage === null ? "disabled" : ""
                        }
                        onClick={() => GetLastPageData()}
                      >
                        <Link className="page-link">Next</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal show={addShow} onHide={handleAddClose} size="lg">
          <Modal.Header>
            <Modal.Title>
              {values.paymentGatewayId ===
              "00000000-0000-0000-0000-000000000000"
                ? "Add"
                : "Edit"}{" "}
              Payment Gateway
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={handleSubmit} autoComplete="off" noValidate>
              <div className="row">
                <div className="col-lg-4 mb-3">
                  <label htmlFor="paymentGatewayName" className="form-label">
                    Payment Gateway
                  </label>
                  <input
                    type="text"
                    max={45}
                    value={values.paymentGatewayName}
                    name="paymentGatewayName"
                    onChange={handleInputChange}
                    className={
                      "form-control" + applyErrorClass("paymentGatewayName")
                    }
                    placeholder="Please Enter Name"
                  />
                  {errors.paymentGatewayName === false ? (
                    <div className="validationerror">Please enter name </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-4 mb-3">
                  <label htmlFor="status" className="form-label">
                    Type
                  </label>
                  <select
                    name="type"
                    value={values.type}
                    onChange={handleInputChange}
                    className={"form-select" + applyErrorClass("type")}
                  >
                    <option value="DEVELOPMENT">DEVELOPMENT</option>
                    <option value="PRODUCTION">PRODUCTION</option>
                  </select>
                </div>
                <div className="col-lg-4 mb-3">
                  <label htmlFor="transactionFee" className="form-label">
                    TRANSACTION FEE (%)
                  </label>
                  <input
                    type="text"
                    value={values.transactionFee}
                    name="transactionFee"
                    onChange={handleInputChange}
                    className={
                      "form-control" + applyErrorClass("transactionFee")
                    }
                    placeholder="Please enter transactionFee"
                  />
                  {errors.transactionFee === false ? (
                    <div className="validationerror">Please enter fee </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-4 mb-3">
                  <label htmlFor="devapiurl" className="form-label">
                    DEV API URL
                  </label>
                  <input
                    type="text"
                    value={values.devapiurl}
                    name="devapiurl"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("devapiurl")}
                    placeholder="Please enter api url"
                  />
                  {errors.devapiurl === false ? (
                    <div className="validationerror">Please enter url </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-4 mb-3">
                  <label htmlFor="devapikey" className="form-label">
                    DEV API KEY
                  </label>
                  <input
                    type="text"
                    value={values.devapikey}
                    name="devapikey"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("devapikey")}
                    placeholder="Please enter key"
                  />
                  {errors.devapikey === false ? (
                    <div className="validationerror">Please enter key </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-4 mb-3">
                  <label htmlFor="devapisecret" className="form-label">
                    DEV API SECRET
                  </label>
                  <input
                    type="text"
                    value={values.devapisecret}
                    name="devapisecret"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("devapisecret")}
                    placeholder="Please enter devapisecret"
                  />
                  {errors.devapisecret === false ? (
                    <div className="validationerror">
                      Please enter devapisecret{" "}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-4 mb-3">
                  <label htmlFor="prodapiurl" className="form-label">
                    PROD API URL
                  </label>
                  <input
                    type="text"
                    value={values.prodapiurl}
                    name="prodapiurl"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("devapiurl")}
                    placeholder="Please enter api url"
                  />
                  {errors.prodapiurl === false ? (
                    <div className="validationerror">Please enter url </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-4 mb-3">
                  <label htmlFor="prodapikey" className="form-label">
                    PROD API KEY
                  </label>
                  <input
                    type="text"
                    value={values.prodapikey}
                    name="prodapikey"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("prodapikey")}
                    placeholder="Please enter key"
                  />
                  {errors.prodapikey === false ? (
                    <div className="validationerror">Please enter key </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-4 mb-3">
                  <label htmlFor="produsername" className="form-label">
                    PROD API SECRET
                  </label>
                  <input
                    type="text"
                    value={values.prodapisecret}
                    name="prodapisecret"
                    onChange={handleInputChange}
                    className={
                      "form-control" + applyErrorClass("prodapisecret")
                    }
                    placeholder="Please enter secret key"
                  />
                  {errors.prodapisecret === false ? (
                    <div className="validationerror">
                      Please enter prodapisecret{" "}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <Modal.Footer>
                  <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                    {btnLoading === false ? (
                      <button type="submit" className="btn btn-primary">
                        {values.paymentGatewayId ===
                        "00000000-0000-0000-0000-000000000000"
                          ? "Submit"
                          : "Update"}
                      </button>
                    ) : (
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled
                      >
                        Please wait...
                      </button>
                    )}
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={resetForm}
                    >
                      Cancel
                    </button>
                  </div>
                </Modal.Footer>
              </div>
            </form>
          </Modal.Body>
        </Modal>
        <DeleteAlert
          show={showDeleteModal}
          handleClose={handleCloseDeleteModal}
          handleDelete={handleDelete}
        />
      </div>
    </div>
  );
};

export default PaymentGateway;
